import React, { useContext, useEffect, useState } from 'react'
import { BasePopupContext } from '../../hooks/usePopup';
import { customStringify } from '../../utils';
import axios from 'axios';
import useApi from "../../hooks/useApi";
import { network_tl } from '../../translations';
import RetryApi from '../../components/RetryApi';
import { DESENDING_ORDER, LISTING_LIMIT, ORDER_DESCENDING, POPUP_LARGE, POPUP_SMALL } from '../../constants';
import { FormattedMessage, useIntl } from 'react-intl';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import Loading from '../../components/Loading';import Table from './Table';
import Filters from './Filters';
;

const Container = () => {
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    search: "",
  })

  const [appliedFilters, setAppliedFilters] = useState({
    search: "",

  })

  const { setPopup } = useContext(BasePopupContext);

  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState({ title: "created_on", order: DESENDING_ORDER });
  let offset = 0;
  const intl = useIntl();
  const { Axios } = useApi();

  const getData = async (curr) => {
    try {
      setLoading(true);
      setError(false);
        if (curr) {
          offset = 0;
        }
        else if (count) {
          offset = currentPage * LISTING_LIMIT - LISTING_LIMIT;
        } else {
          offset = 0;
        }
        const result = await Axios.get(`api/influencer/influencers-worked?limit=${LISTING_LIMIT}&offset=${offset}&search=${appliedFilters.search.trim()}`);
        setData(result.data.payload);
        setLoading(false);
        setCount(result.data.count)
    } catch (e) {
      if (axios.isCancel(e)) {

      } else if (e.response) {
        setError(customStringify(e.response.data.description))
        setLoading(false)
      } else {
        setError(network_tl(intl))
        setLoading(false)
      }
    }
  }

  useEffect(() => {
    getData()
  }, [currentPage, sort])

  useEffect(() => {
    getData(1)
  }, [appliedFilters])

  const applyFilters = () => {
    const copy = _.cloneDeep(filters)
    setCurrentPage(1);
    setAppliedFilters(copy)
  }

  const resetFilters = () => {
    setCurrentPage(1)
    setFilters({
      search: "",
      
    })
    setAppliedFilters({
      search: "",
    })
  }

  const refreshListing = () => {
    setCurrentPage(1);
    getData(1)
  }


  return (
    <div className=' rounded-[6px] border-base border-2  p-5'>
        <Filters
        filters={filters}
        setFilters={setFilters}
        applyFilters={applyFilters}
        resetFilters={resetFilters}
        appliedFilters={appliedFilters}
      />
      <div className='py-5'>
        

        { loading ?
          <Loading />:
          error ?
            <>
              <RetryApi error={error} retry={getData} />
            </>
            :
            <Table
              refreshListing={refreshListing}
              data={data}
              // loading={loading}
              setSort={setSort}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              count={count}
            />
           
        }


      </div>
    </div>
  )
}

export default Container